import VueRouter from "vue-router";
import { BaseGoToHelper } from "./goToHelper";
import { $t } from "./t";

export enum RentalRouteNames {
  RENTAL_TABLE = "RENTAL_TABLE",
  RENTAL_DETAIL = "RENTAL_DETAIL"
}

type Tab = { newTab?: boolean };
type Partner = { partnerId: string };
type Rental = { rentalId: string };
type Query = { query?: Record<string, string> };

export class RentalGoToHelper extends BaseGoToHelper {
  static get breadCrumbs() {
    const locations = RentalGoToHelper.locations;

    return {
      RentalTable: (partnerId: string) => {
        return {
          text: $t("nav.RENTAL_TABLE.title").toString(),
          exact: true,
          to: locations.rentalTable({ partnerId })
        };
      },
      RentalDetail: (partnerId: string, rentalId: string) => {
        return {
          text: $t("common.nouns.detail").toString(),
          exact: true,
          to: locations.rentalDetail({ partnerId, rentalId: rentalId })
        };
      }
    };
  }

  constructor(protected readonly router: VueRouter) {
    super(router);
  }

  static locations = {
    rentalTable: (d: Partner & Query) => {
      return {
        name: RentalRouteNames.RENTAL_TABLE,
        params: { partnerId: d.partnerId },
        query: d.query
      };
    },
    rentalDetail: (d: Partner & Rental & Query) => {
      return {
        name: RentalRouteNames.RENTAL_DETAIL,
        params: { partnerId: d.partnerId, rentalId: d.rentalId },
        query: d.query
      };
    }
  };

  goToRentalTable(d: Tab & Partner) {
    this.go(RentalGoToHelper.locations.rentalTable(d), d.newTab);
  }

  goToRentalDetail(d: Tab & Partner & Rental) {
    this.go(RentalGoToHelper.locations.rentalDetail(d), d.newTab);
  }
}
